export default "__VITE_ASSET__JKaSMwCa__"